<template>
  <div class="hall-top-area substitute-page-wrap">
    <div class="container">
      <div class="hall-top-area-inner">
        <h1 id="headerText" class="page-head text-uppercase mb-5">
          {{ headerText }}
        </h1>
        <div class="hall-top-right">
          <div class="right-search-hld">
            <div class="search-hall">
              <input
                type="text"
                name=""
                id=""
                value=""
                placeholder="Search"
                @keyup="searchExhibitors2"
                v-on:keydown.enter.prevent="searchExhibitors2"
                v-model="searchtext"
              />
              <img src="../assets/Images/icons/search.svg" />
            </div>
            <a href="javascript:void(0)" @click="searchExhibitors2">GO</a>
          </div>
          <!-- <div class="hall-view-btn">
            <img
              src="../assets/Images/grid-view-dark.svg"
              class="grid-dark"
              v-on:click="hallGridView"
            />
            <img
              src="../assets/Images/list-dark.svg"
              class="list-dark"
              v-on:click="hallListView"
            />
          </div> -->
        </div>
      </div>
    </div>
    <div class="hall-booth-inner-wrap">
      <div class="container">
        <div class="row">
          <div
            class="col-md-6 col-12 single-hall-booth-wrap"
            v-bind:id="item.id"
            v-bind:key="item.id"
            v-for="item in Exhibitorlist"
          >
            <div
              class="single-booth"
              @click.prevent="loadView(item.id)"
              :data-tag="'exhibitorview/' + item.id + '/' + item.Name"
            >
              <div class="booth-image">
                <img :src="item.Logo" alt="Loading..." />
              </div>
              <div class="booth-description">
                <p>{{ item.Name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.substitute-page-wrap {
  .hall-top-area {
    padding: 15px 0;
  }
  .hall-top-area-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search-hall {
    border: 1px solid #dfdfdf;
    position: relative;
    border-radius: 4px 0 0 4px;
  }
  .search-hall input[type="text"] {
    border: none;
    height: 42px;
    width: 400px;
    background: transparent;
    padding: 0 15px 0 48px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
  .search-hall img {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
  }
  .hall-booth-inner-wrap {
    background: #eee;
  }
  .hall-booth-inner-wrap {
    padding: 20px 0;
    margin-top: 30px;
  }
  .hall-booth-inner-wrap .single-booth {
    padding: 15px;
    background: #bcbcbd;
    border-radius: 10px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    height: 100% !important;
  }
  .hall-booth-inner-wrap .booth-image {
    height: 148px;
    background: #fff;
    width: 200px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex: 200px 0 0;
  }
  .hall-booth-inner-wrap .booth-image img {
    max-width: 100%;
    height: auto;
  }
  .hall-booth-inner-wrap .booth-description {
    padding-left: 18px;
  }
  .hall-booth-inner-wrap .booth-description p {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    margin: 0;
  }
  .exhibitors-hall-grid-view-lite .single-booth {
    flex-direction: column;
    width: 100%;
  }
  .exhibitors-hall-grid-view-lite .single-booth .booth-image {
    height: 250px;
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .hall-view-btn {
    margin-left: 15px;
  }
  .hall-view-btn img {
    position: relative !important;
    left: 0;
    top: 0;
  }
  .hall-top-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .list-dark {
    display: none;
  }
  .single-hall-booth-wrap {
    margin-top: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .substitute-page-wrap {
    .hall-top-area-inner {
      align-items: flex-start;
      flex-direction: column;
    }
    .hall-booth-inner-wrap {
      min-height: 100vh;
      max-height: max-content;
    }
    .search-hall {
      width: 100%;
    }
    .search-hall input[type="text"] {
      width: 100%;
    }
    .hall-top-area-inner h3 {
      font-size: 22px;
    }
    .booth-image {
      height: 130px;
      width: 140px;
    }
    .exhibitors-hall-grid-view-lite .single-booth .booth-image {
      height: 95px;
    }
    .hall-top-right {
      width: 100%;
    }
    .hall-top-right .right-search-hld {
      width: 100%;
    }
  }
}
@media only screen and (max-width: 767px) {
  .substitute-page-wrap {
    .hall-top-area-inner {
      align-items: flex-start;
      flex-direction: column;
    }
    .search-hall {
      width: 100%;
    }
    .search-hall input[type="text"] {
      width: 100%;
    }
    .hall-top-area-inner h3 {
      font-size: 22px;
    }
    .booth-image {
      height: 130px;
      width: 140px;
    }
    .exhibitors-hall-grid-view-lite .single-booth .booth-image {
      height: 95px;
    }
    .hall-top-right {
      width: 100%;
    }
    .hall-top-right .right-search-hld {
      width: 100%;
    }
  }
  .hall-top-area.substitute-page-wrap
    .exhibitors-hall-grid-view-lite
    .single-booth
    .booth-image {
    height: 170px;
    flex: 170px 0 0;
    border: 0;
  }
}
</style>
<script>
import router from "../router";
import store from "../store";
import db from "../components/firebaseInit";
import jQuery from "jquery";
import analytics from "@/components/Analytics";
let $ = jQuery;
// let lastVisible = null;
// let hasMore = true;
var self;
import axios from "axios";
var interval = null;
export default {
  data() {
    return {
      headerText: this.$t("expo.exhibitors"),
      id: null,
      Name: null,
      BoothNo: null,
      Category: null,
      Email: null,
      Website: null,
      Image: null,
      Profile: null,
      Phone: null,
      HotspotImageUrL: null,
      MappedContacts: [],
      BroadcastData: [],
      exid: null,
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      searchtext: "",
      filtertext: "",
      IsShowNoDataFound: false,
      IsShowCancelButton: false,
      IsSearchMode: false,
      lastVisible: null,
      ExhibitorData: [],
      DropFilter: [],
      Exhibitorlist: [],
      ExhibitorSettings: [],
      totalCount: 0,
      stRange: 0,
      endRange: 7,
      textColor: "black",
      clientID: this.$store.getters.getClient[0].id,
      eventId: "",
      sortedSocialLinks: [],
      ExpoHallBackgroundImage: "",
      searchType: 0,
      showTooltips: false,
      orderBy: "BoothNo", //("Name","BoothNo")
    };
  },
  methods: {
    hallGridView() {
      $(".hall-booth-inner-wrap").addClass("exhibitors-hall-grid-view-lite");
      $(".grid-dark").css("display", "none");
      $(".list-dark").css("display", "block");
      $(".single-hall-booth-wrap").removeClass("col-12");
      // $(".single-hall-booth-wrap").addClass("col-6");
    },
    hallListView() {
      $(".hall-booth-inner-wrap").removeClass("exhibitors-hall-grid-view-lite");
      $(".list-dark").css("display", "none");
      $(".grid-dark").css("display", "block");
      $(".single-hall-booth-wrap").removeClass("col-6");
      $(".single-hall-booth-wrap").addClass("col-12");
    },
    loopArray: function (arr) {
      var obj = [];
      var i;

      for (i = 0; i < arr.length; i++) {
        let socialkeys = Object.keys(arr[i]);
        let socialvaues = Object.values(arr[i]);
        if (socialvaues[0] !== "") {
          if (socialvaues[0].indexOf("http") < 0) {
            socialvaues[0] = "http://" + socialvaues[0];
          }
        }
        obj.push({ key: socialkeys[0], value: socialvaues[0] });
      }
      this.sortedSocialLinks = obj;
      this.sortedSocialLinks.sort(function (x, y) {
        let a = x.key.toUpperCase(),
          b = y.key.toUpperCase();
        return a == b ? 0 : a > b ? 1 : -1;
      });
    },
    showtooltip: function (val) {
      $(".custom-tool-tip-left").hide();
      $(".custom-tool-tip-right").hide();
      $("#" + val).show();
      //$('.custom-tool-tip-left').show();
    },
    openBooth(data) {
      store.commit("addExhibitorID", data.id);
      router.push({ name: "ExhibitorsView" });
    },
    closetooltip: function (val) {
      $("#" + val).hide();
      $(".custom-tool-tip-left").hide();
      $(".custom-tool-tip-right").hide();
    },
    getfilters() {
      self.DropFilter = [];
      // this.DropFilter.push({ id: "All", value: "All" });
      // this.DropFilter.push({ id: "General", value: "General" });
      // this.DropFilter.push({ id: "Platinum", value: "Platinum" });
      // this.DropFilter.push({ id: "Gold", value: "Gold" });
      // this.DropFilter.push({ id: "Silver", value: "Silver" });
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      self.DropFilter.push({ id: "All", value: "All" });
      var docref = db
        .collection(obj.eventcollectionname)
        .doc("ExhibitorCategories")
        .collection("Category");

      docref
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.DropFilter.push({ id: doc.id, value: doc.id });
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },

    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    getEventID() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.eventid;
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          debugger;
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    getExhibitors: function () {
      debugger;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // console.log("EventColName : " + obj.eventcollectionname);
      this.Exhibitorlist = [];
      var docRef;

      self.filterText = $("#selFilter option:selected").text();
      //alert(filterText);
      if (self.filterText.trim() != "All") {
        if (self.filterText != "") {
          docRef = db
            .collection(obj.eventcollectionname)
            .doc("ExhibitorList")
            .collection("Exhibitors")
            .orderBy(self.orderBy, "asc")
            .where("Category", "==", self.filterText)
            .where("IsPublished", "==", true);
        } else {
          docRef = db
            .collection(obj.eventcollectionname)
            .doc("ExhibitorList")
            .collection("Exhibitors")
            .orderBy(self.orderBy, "asc")
            .where("IsPublished", "==", true);
        }
      } else {
        docRef = db
          .collection(obj.eventcollectionname)
          .doc("ExhibitorList")
          .collection("Exhibitors")
          .orderBy(self.orderBy, "asc")
          .where("IsPublished", "==", true);
      }

      if (self.searchtext.trim() != "") {
        debugger;
        if (self.searchType == 0) {
          $("#divExhibitor").html("");
          self.hideLoader();
          self.Exhibitorlist = [];

          docRef
            .get()
            .then((querySnapshot) => {
              var ctr = 0;
              var id = "";
              this.Exhibitorlist = [];
              debugger;
              querySnapshot.forEach((doc) => {
                debugger;
                id += doc.id + ",";

                var webSite = "";
                if (doc.data().Website !== "") {
                  if (doc.data().Website.indexOf("http") < 0) {
                    webSite = "http://" + doc.data().Website;
                  } else {
                    webSite = doc.data().Website;
                  }
                }
                debugger;
                var socLinks = doc.data().SocialLinks;
                self.loopArray(socLinks);
                socLinks = self.sortedSocialLinks;

                var tbObj = new Object();
                (tbObj.sino = ctr++),
                  (tbObj.id = doc.id),
                  (tbObj.Name =
                    doc.data().Name != undefined ? doc.data().Name : ""),
                  (tbObj.Logo =
                    doc.data().Logo != undefined ? doc.data().Logo : ""),
                  (tbObj.Email =
                    doc.data().Email != undefined ? doc.data().Email : ""),
                  (tbObj.Category =
                    doc.data().Category != undefined
                      ? doc.data().Category
                      : ""),
                  (tbObj.BoothNo =
                    doc.data().BoothNo != undefined ? doc.data().BoothNo : ""),
                  (tbObj.HotspotImageUrL =
                    doc.data().HotspotImageURL != undefined
                      ? doc.data().HotspotImageURL
                      : ""),
                  (tbObj.Website = webSite != undefined ? webSite : ""),
                  (tbObj.Profile =
                    (doc.data().Profile != undefined ? doc.data().Profile : "")
                      .replace(/<[^>]*>/g, "\n\r")
                      .substring(0, 300) + "..."),
                  (tbObj.Phone =
                    doc.data().Phone != undefined ? doc.data().Phone : ""),
                  (tbObj.Image =
                    doc.data().Logo != undefined ? doc.data().Logo : ""),
                  (tbObj.SocialLinks =
                    doc.data().SocialLinks != undefined ? socLinks : []),
                  (tbObj.MappedContacts = doc.data().MappedContacts =
                    undefined ? doc.data().MappedContacts : []),
                  (tbObj.contactcount =
                    doc.data().MappedContacts.length != undefined
                      ? doc.data().MappedContacts.length
                      : 0),
                  (tbObj.Files =
                    doc.data().Resources != undefined
                      ? doc.data().Resources
                      : []),
                  (tbObj.fileLength =
                    doc.data().Resources.length != undefined
                      ? doc.data().Resources.length
                      : 0),
                  (tbObj.ShowcaseVideoURL =
                    doc.data().ShowcaseVideoURL != undefined
                      ? doc.data().ShowcaseVideoURL
                      : "");

                if (
                  tbObj.Name.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Email.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Category.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Website.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  ) ||
                  tbObj.Profile.toLowerCase().includes(
                    self.searchtext.toLowerCase()
                  )
                ) {
                  self.Exhibitorlist.push(tbObj);

                  // console.log("count " + self.Exhibitorlist.length);
                  this.totalCount = self.Exhibitorlist.length;

                  this.stRange = 0;
                  if (self.Exhibitorlist.length < 7) {
                    this.endRange = self.Exhibitorlist.length;
                  } else {
                    this.endRange = 7;
                  }
                  if (self.orderBy == "BoothNo") {
                    self.Exhibitorlist.sort(function (a, b) {
                      let aName = parseInt(a.BoothNo);
                      let bName = parseInt(b.BoothNo);
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                  } else {
                    self.Exhibitorlist.sort(function (a, b) {
                      let aName = a.Name.trim().toLowerCase();
                      let bName = b.Name.trim().toLowerCase();
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                  }

                  store.commit("addExbList", id.substring(0, id.length - 1));
                }
                var exhibitorIds1 = "";
                self.Exhibitorlist.map((item) => {
                  exhibitorIds1 += item.id + ",";
                });

                if (exhibitorIds1 != "") {
                  exhibitorIds1 = exhibitorIds1.substring(
                    0,
                    exhibitorIds1.length - 1
                  );
                }
                store.commit("addExbList", exhibitorIds1);
              });

              if (self.Exhibitorlist.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            })
            .catch((error) => {
              console.log(error);
              self.hideLoader();

              self.IsShowNoDataFound = true;
              return false;
            });
        } else {
          self.IsSearchMode = true;
          $("#divExhibitor").html("");

          //----------------------------------------------------------------------------------------
          var hostUrl = location.host.toLowerCase();
          var searchUrl = "";
          if (hostUrl.includes("localhost")) {
            searchUrl =
              "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchexhibitors/" +
              this.searchtext;
          } else {
            if (hostUrl.includes("uat")) {
              searchUrl =
                "https://us-central1-uate2monair.cloudfunctions.net/app/api/searchexhibitors/" +
                this.searchtext;
            } else {
              searchUrl =
                "https://us-central1-e2monair.cloudfunctions.net/app/api/searchexhibitors/" +
                this.searchtext;
            }
          }
          //----------------------------------------------------------------------------------------------------

          console.log(this.clientID);
          this.eventId = this.getEventID();
          console.log(this.eventId);

          //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

          let headers = {
            "Content-Type": "application/json",
            apikey: "ws2000rb28082019",
            InstancePrefix: "OA",
            clientID: this.clientID, // "C1591205467009",
            Env: "UAT",
            eventID: this.eventId, //"E1591206650065",
          };
          self.showLoader();
          axios
            .get(searchUrl, false, {
              headers: headers,
            })
            .then((responseData) => {
              let data = responseData.data;
              self.hideLoader();
              console.log(data);
              var ctr = 0;
              var id = "";
              self.Exhibitorlist = [];
              for (var i = 0; i < data.length; i++) {
                if (data[i].IsPublished === true) {
                  id += data[i].ExhibitorId + ",";
                  var webSite = "";
                  if (data[i].Website !== "") {
                    if (data[i].Website.indexOf("http") < 0) {
                      webSite = "http://" + data[i].Website;
                    } else {
                      webSite = data[i].Website;
                    }
                  }
                  debugger;
                  var socLinks = data[i].SocialLinks;
                  self.loopArray(socLinks);
                  socLinks = self.sortedSocialLinks;

                  var tbObj = new Object();

                  (tbObj.sino = ctr++),
                    (tbObj.id = data[i].ExhibitorId),
                    (tbObj.Name =
                      data[i].Name != undefined ? data[i].Name : ""),
                    (tbObj.Logo =
                      data[i].Logo != undefined ? data[i].Logo : ""),
                    (tbObj.Email =
                      data[i].Email != undefined ? data[i].Email : ""),
                    (tbObj.Category =
                      data[i].Category != undefined ? data[i].Category : ""),
                    (tbObj.BoothNo =
                      data[i].BoothNo != undefined ? data[i].BoothNo : ""),
                    (tbObj.HotspotImageUrL =
                      data[i].HotspotImageURL != undefined
                        ? data[i].HotspotImageURL
                        : ""),
                    (tbObj.Website = webSite != undefined ? webSite : ""),
                    (tbObj.Profile =
                      (data[i].Profile != undefined ? data[i].Profile : "")
                        .replace(/<[^>]*>/g, "\n\r")
                        .substring(0, 300) + "..."),
                    (tbObj.Phone =
                      data[i].Phone != undefined ? data[i].Phone : ""),
                    (tbObj.Image =
                      data[i].Logo != undefined ? data[i].Logo : ""),
                    (tbObj.SocialLinks =
                      data[i].SocialLinks != undefined ? socLinks : []),
                    (tbObj.MappedContacts =
                      data[i].MappedContacts != undefined
                        ? data[i].MappedContacts
                        : []),
                    (tbObj.contactcount =
                      data[i].MappedContacts != undefined
                        ? data[i].MappedContacts.length
                        : 0),
                    (tbObj.Files =
                      data[i].Resources != undefined ? data[i].Resources : []),
                    (tbObj.fileLength =
                      data[i].Resources != undefined
                        ? data[i].Resources.length
                        : 0),
                    (tbObj.ShowcaseVideoURL =
                      data[i].ShowcaseVideoURL != undefined
                        ? data[i].ShowcaseVideoURL
                        : "");

                  self.Exhibitorlist.push(tbObj);

                  // console.log("count " + self.Exhibitorlist.length);
                  this.totalCount = self.Exhibitorlist.length;

                  this.stRange = 0;
                  if (self.Exhibitorlist.length < 7) {
                    this.endRange = self.Exhibitorlist.length;
                  } else {
                    this.endRange = 7;
                  }
                  debugger;
                  if (self.orderBy == "BoothNo") {
                    self.Exhibitorlist.sort(function (a, b) {
                      let aName = parseInt(a.BoothNo);
                      let bName = parseInt(b.BoothNo);
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                  } else {
                    self.Exhibitorlist.sort(function (a, b) {
                      let aName = a.Name.trim().toLowerCase();
                      let bName = b.Name.trim().toLowerCase();
                      if (aName < bName) {
                        return -1;
                      }
                      if (aName > bName) {
                        return 1;
                      }
                      return 0;
                    });
                  }
                  store.commit("addExbList", id.substring(0, id.length - 1));
                  var exhibitorIds3 = "";
                  self.Exhibitorlist.map((item) => {
                    exhibitorIds3 += item.id + ",";
                  });

                  if (exhibitorIds3 != "") {
                    exhibitorIds3 = exhibitorIds3.substring(
                      0,
                      exhibitorIds3.length - 1
                    );
                  }
                  store.commit("addExbList", exhibitorIds3);

                  // debugger
                  // if(this.totalCount == 1)
                  // {
                  //   this.loadView(self.Exhibitorlist[0].id);
                  // }
                }
              }

              if (self.Exhibitorlist.length > 0) {
                self.IsShowNoDataFound = false;
              } else {
                self.IsShowNoDataFound = true;
              }
            })
            .catch((error) => {
              console.log(error);
              self.hideLoader();
              self.IsShowNoDataFound = true;
            });

          //$.ajax({
          //  url: searchUrl,
          //  headers: {
          //    "Content-Type": "application/json",
          //    apikey: "ws2000rb28082019",
          //    InstancePrefix: "OA",
          //    clientID: this.clientID, // "C1591205467009",
          //    Env: "UAT",
          //    eventID: this.eventId, //"E1591206650065",
          //  },
          //  beforeSend: function () {
          //    self.showLoader();
          //  },
          //  type: "GET",
          //  // mode: 'cors',
          //  //credentials: "include",
          //  crossDomain: true,
          //  dataType: "json",
          //  processData: false,

          //  success: function (data) {
          //    self.hideLoader();
          //    console.log(data);
          //    var ctr = 0;
          //    var id = "";
          //    self.Exhibitorlist = [];
          //    for (var i = 0; i < data.length; i++) {
          //      if (data[i].IsPublished === true) {
          //        id += data[i].ExhibitorId + ",";
          //        var webSite = "";
          //        if (data[i].Website !== "") {
          //          if (data[i].Website.indexOf("http") < 0) {
          //            webSite = "http://" + data[i].Website;
          //          } else {
          //            webSite = data[i].Website;
          //          }
          //        }
          //        debugger;
          //        var socLinks = data[i].SocialLinks;
          //        self.loopArray(socLinks);
          //        socLinks = self.sortedSocialLinks;

          //        // if (
          //        //   data[i].SocialLinks[0].Facebook !== "" &&
          //        //   data[i].SocialLinks[0].Facebook !== undefined
          //        // ) {
          //        //   if (data[i].SocialLinks[0].Facebook.indexOf("http") < 0) {
          //        //     socLinks[0].Facebook =
          //        //       "http://" + data[i].SocialLinks[0].Facebook;
          //        //   }
          //        // }
          //        // if (
          //        //   data[i].SocialLinks[1].Twitter !== "" &&
          //        //   data[i].SocialLinks[1].Twitter !== undefined
          //        // ) {
          //        //   if (data[i].SocialLinks[1].Twitter.indexOf("http") < 0) {
          //        //     socLinks[1].Twitter =
          //        //       "http://" + data[i].SocialLinks[1].Twitter;
          //        //   }
          //        // }
          //        // if (
          //        //   data[i].SocialLinks[2].LinkedIn !== "" &&
          //        //   data[i].SocialLinks[2].Twitter !== undefined
          //        // ) {
          //        //   if (data[i].SocialLinks[2].LinkedIn.indexOf("http") < 0) {
          //        //     socLinks[2].LinkedIn =
          //        //       "http://" + data[i].SocialLinks[2].LinkedIn;
          //        //   }
          //        // }

          //        var tbObj = new Object();

          //        (tbObj.sino = ctr++),
          //          (tbObj.id = data[i].ExhibitorId),
          //          (tbObj.Name =
          //            data[i].Name != undefined ? data[i].Name : ""),
          //          (tbObj.Logo =
          //            data[i].Logo != undefined ? data[i].Logo : ""),
          //          (tbObj.Email =
          //            data[i].Email != undefined ? data[i].Email : ""),
          //          (tbObj.Category =
          //            data[i].Category != undefined ? data[i].Category : ""),
          //          (tbObj.BoothNo =
          //            data[i].BoothNo != undefined ? data[i].BoothNo : ""),
          //          (tbObj.HotspotImageUrL =
          //            data[i].HotspotImageURL != undefined
          //              ? data[i].HotspotImageURL
          //              : ""),
          //          (tbObj.Website = webSite != undefined ? webSite : ""),
          //          (tbObj.Profile =
          //            (data[i].Profile != undefined ? data[i].Profile : "")
          //              .replace(/<[^>]*>/g, "\n\r")
          //              .substring(0, 300) + "..."),
          //          (tbObj.Phone =
          //            data[i].Phone != undefined ? data[i].Phone : ""),
          //          (tbObj.Image =
          //            data[i].Logo != undefined ? data[i].Logo : ""),
          //          (tbObj.SocialLinks =
          //            data[i].SocialLinks != undefined ? socLinks : []),
          //          (tbObj.MappedContacts =
          //            data[i].MappedContacts != undefined
          //              ? data[i].MappedContacts
          //              : []),
          //          (tbObj.contactcount =
          //            data[i].MappedContacts != undefined
          //              ? data[i].MappedContacts.length
          //              : 0),
          //          (tbObj.Files =
          //            data[i].Resources != undefined ? data[i].Resources : []),
          //          (tbObj.fileLength =
          //            data[i].Resources != undefined
          //              ? data[i].Resources.length
          //              : 0),
          //          (tbObj.ShowcaseVideoURL =
          //            data[i].ShowcaseVideoURL != undefined
          //              ? data[i].ShowcaseVideoURL
          //              : "");

          //        self.Exhibitorlist.push(tbObj);

          //        // console.log("count " + self.Exhibitorlist.length);
          //        this.totalCount = self.Exhibitorlist.length;

          //        this.stRange = 0;
          //        if (self.Exhibitorlist.length < 7) {
          //          this.endRange = self.Exhibitorlist.length;
          //        } else {
          //          this.endRange = 7;
          //        }
          //        debugger;
          //        if (self.orderBy == "BoothNo") {
          //          self.Exhibitorlist.sort(function (a, b) {
          //            let aName = parseInt(a.BoothNo);
          //            let bName = parseInt(b.BoothNo);
          //            if (aName < bName) {
          //              return -1;
          //            }
          //            if (aName > bName) {
          //              return 1;
          //            }
          //            return 0;
          //          });
          //        } else {
          //          self.Exhibitorlist.sort(function (a, b) {
          //            let aName = a.Name.trim().toLowerCase();
          //            let bName = b.Name.trim().toLowerCase();
          //            if (aName < bName) {
          //              return -1;
          //            }
          //            if (aName > bName) {
          //              return 1;
          //            }
          //            return 0;
          //          });
          //        }
          //        store.commit("addExbList", id.substring(0, id.length - 1));
          //        var exhibitorIds3 = "";
          //        self.Exhibitorlist.map((item) => {
          //          exhibitorIds3 += item.id + ",";
          //        });

          //        if (exhibitorIds3 != "") {
          //          exhibitorIds3 = exhibitorIds3.substring(
          //            0,
          //            exhibitorIds3.length - 1
          //          );
          //        }
          //        store.commit("addExbList", exhibitorIds3);

          //        // debugger
          //        // if(this.totalCount == 1)
          //        // {
          //        //   this.loadView(self.Exhibitorlist[0].id);
          //        // }
          //      }
          //    }

          //    if (self.Exhibitorlist.length > 0) {
          //      self.IsShowNoDataFound = false;
          //    } else {
          //      self.IsShowNoDataFound = true;
          //    }
          //  },
          //  error: function () {
          //    console.log("error");
          //    self.hideLoader();

          //    self.IsShowNoDataFound = true;
          //    return false;
          //  },
          //});
          //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
        }
      } else {
        docRef
          .get()
          .then((querySnapshot) => {
            var ctr = 0;
            var id = "";
            // if (this.DropFilter.length == 0) {
            //   this.getfilters();
            // }
            querySnapshot.forEach((doc) => {
              if (this.searchtext !== "") {
                if (querySnapshot.docs.length == 1) {
                  this.loadView(doc.id);
                }
              } else {
                id += doc.id + ",";
                //console.log(doc.data().HotspotImageURL);
                var webSite = "";
                if (doc.data().Website !== "") {
                  if (doc.data().Website.indexOf("http") < 0) {
                    webSite = "http://" + doc.data().Website;
                  } else {
                    webSite = doc.data().Website;
                  }
                }
                debugger;
                var socLinks = doc.data().SocialLinks;
                self.loopArray(socLinks);
                socLinks = self.sortedSocialLinks;

                // if (
                //   doc.data().SocialLinks[0].Facebook !== "" &&
                //   doc.data().SocialLinks[0].Facebook !== undefined
                // ) {
                //   if (doc.data().SocialLinks[0].Facebook.indexOf("http") < 0) {
                //     socLinks[0].Facebook =
                //       "http://" + doc.data().SocialLinks[0].Facebook;
                //   }
                // }
                // if (
                //   doc.data().SocialLinks[1].Twitter !== "" &&
                //   doc.data().SocialLinks[1].Twitter !== undefined
                // ) {
                //   if (doc.data().SocialLinks[1].Twitter.indexOf("http") < 0) {
                //     socLinks[1].Twitter =
                //       "http://" + doc.data().SocialLinks[1].Twitter;
                //   }
                // }
                // if (
                //   doc.data().SocialLinks[2].LinkedIn !== "" &&
                //   doc.data().SocialLinks[2].Twitter !== undefined
                // ) {
                //   if (doc.data().SocialLinks[2].LinkedIn.indexOf("http") < 0) {
                //     socLinks[2].LinkedIn =
                //       "http://" + doc.data().SocialLinks[2].LinkedIn;
                //   }
                // }

                this.Exhibitorlist.push({
                  sino: ctr++,
                  id: doc.id,
                  Name: doc.data().Name,
                  Logo: doc.data().Logo,
                  Email: doc.data().Email,
                  Category: doc.data().Category,
                  BoothNo: doc.data().BoothNo,
                  HotspotImageUrL: doc.data().HotspotImageURL,
                  Website: webSite,
                  Profile:
                    doc
                      .data()
                      .Profile.replace(/<[^>]*>/g, "\n\r")
                      .substring(0, 300) + "...",
                  Phone: doc.data().Phone,
                  Image: doc.data().Logo,
                  SocialLinks: socLinks,
                  MappedContacts: doc.data().MappedContacts,
                  contactcount: doc.data().MappedContacts.length,
                  Files: doc.data().Resources,
                  fileLength: doc.data().Resources.length,
                  ShowcaseVideoURL: doc.data().ShowcaseVideoURL,
                });
              }

              // this.DropFilter.push({
              //   id: doc.data().Category,
              //   value: doc.data().Category,
              // });
            });
            if (self.orderBy == "BoothNo") {
              self.Exhibitorlist.sort(function (a, b) {
                let aName = parseInt(a.BoothNo);
                let bName = parseInt(b.BoothNo);
                if (aName < bName) {
                  return -1;
                }
                if (aName > bName) {
                  return 1;
                }
                return 0;
              });
            } else {
              self.Exhibitorlist.sort(function (a, b) {
                let aName = a.Name.trim().toLowerCase();
                let bName = b.Name.trim().toLowerCase();
                if (aName < bName) {
                  return -1;
                }
                if (aName > bName) {
                  return 1;
                }
                return 0;
              });
            }

            this.totalCount = self.Exhibitorlist.length;
            this.stRange = 0;
            this.endRange = 7;
            if (this.endRange > this.totalCount) {
              this.endRange = this.totalCount;
            }
            store.commit("addExbList", id.substring(0, id.length - 1));
            var exhibitorIds2 = "";
            self.Exhibitorlist.map((item) => {
              exhibitorIds2 += item.id + ",";
            });

            if (exhibitorIds2 != "") {
              exhibitorIds2 = exhibitorIds2.substring(
                0,
                exhibitorIds2.length - 1
              );
            }
            store.commit("addExbList", exhibitorIds2);
            debugger;
            if (this.totalCount == 1) {
              this.loadView(self.Exhibitorlist[0].id);
            }
          })
          .catch((error) => {
            debugger;
            alert(error);
          });
      }
    },
    loadhotspotterscripts: function () {
      let externalScript = document.createElement("script");
      externalScript.setAttribute(
        // "src",
        // "https://ajax.googleapis.com/ajax/libs/jquery/1.8.3/jquery.min.js"
        "src",
        "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
      );
      externalScript.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript);

      let externalScript1 = document.createElement("script");
      externalScript1.setAttribute(
        // "type",
        // "https://ajax.googleapis.com/ajax/libs/jqueryui/1.9.2/jquery-ui.min.js"
        "type",
        "https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js"
      );
      externalScript1.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript1);

      let externalScript3 = document.createElement("script");
      externalScript3.setAttribute(
        "src",
        "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.js?alt=media"
      );
      externalScript3.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript3);

      let externalScript4 = document.createElement("script");
      externalScript4.setAttribute(
        "src",
        "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fjquery-hotspotter.min.js?alt=media"
      );
      externalScript4.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript4);

      let externalScript5 = document.createElement("script");
      externalScript5.setAttribute(
        "src",
        "https://resources.e2m.live/e2monair.appspot.com/Hotspotter%2Fjs%2Fother.js?alt=media"
      );
      externalScript5.setAttribute("type", "text/javascript");
      document.body.appendChild(externalScript5);
    },
    getPrvLot: function () {
      this.stRange = parseInt(this.stRange) - 7;
      if (this.stRange <= 0) {
        this.stRange = 0;
      }

      this.endRange = parseInt(this.endRange) - 7;
      if (this.endRange >= this.totalCount) {
        this.endRange = this.totalCount;
      }
      if (this.endRange % 7 !== 0) {
        this.endRange = parseInt(this.endRange) + (7 - (this.endRange % 7));
      }
    },
    getNextLot: function () {
      this.stRange = parseInt(this.stRange) + 7;

      this.endRange = parseInt(this.endRange) + 7;
      if (this.endRange > this.totalCount) {
        this.endRange = this.totalCount;
      }
    },
    loadView(id) {
      if (screen.width > 767) {
        store.commit("addExhibitorID", id);
        router.push({ name: "ExhibitorsView" });
      } else {
        store.commit("addExhibitorID", id);
        router.push({ name: "exhibitorsboothlite" });
      }
    },
    cancelSearch: function () {
      self.IsSearchMode = false;
      self.IsShowNoDataFound = false;
      self.IsShowCancelButton = false;
      self.pageSize = 100;
      self.pageIndex = 0;
      self.totalRecords = 1;
      self.attendeeData = [];
      self.searchtext = "";
      self.Exhibitorlist = [];
      self.getExhibitors();
    },
    searchExhibitors2: function () {
      debugger;
      if (self.searchtext !== "") {
        self.totalRecords = 1;
        self.firstPageCalled = false;
        self.pageIndex = 0;
        self.hasMore = true;
        self.lastVisible = null;
        self.Exhibitorlist = [];
        self.getExhibitors();
      } else {
        self.lastVisible = null;
        self.Exhibitorlist = [];
        self.getExhibitors();
      }
    },
    searchExhibitors: function () {
      self.totalRecords = 1;
      self.firstPageCalled = false;
      self.pageIndex = 0;
      self.hasMore = true;
      self.lastVisible = null;
      self.Exhibitorlist = [];
      self.getExhibitors();
    },
    getSettings: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().ExpoHallBackgroundImage !== undefined) {
              if (doc.data().ExpoHallBackgroundImage !== "") {
                self.ExpoHallBackgroundImage =
                  doc.data().ExpoHallBackgroundImage;
              } else {
                self.ExpoHallBackgroundImage =
                  "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
              }
            } else {
              self.ExpoHallBackgroundImage =
                "https://resources.e2m.live/e2monair.appspot.com/OA_UAT%2FSymposium%20Exhibitor%20Booth%2Fexpo-bg.jpg?alt=media&token=3eb488b8-32fd-4fae-8d49-b35a4e9a3ded";
            }

            if (doc.data().EnableExhibitorFilterAndSearchOption == false) {
              if (document.getElementById("dvFilter") !== undefined) {
                if (document.getElementById("dvFilter") !== null) {
                  //alert('hi');
                  document.getElementById("dvFilter").style.visibility =
                    "hidden";
                }
              }
            }
            if (doc.data().IsExpoAlertEnabled == true) {
              self.showTooltips = true;
            } else {
              self.showTooltips = false;
            }

            if (doc.data().OrderBy) {
              debugger;
              self.orderBy = doc.data().OrderBy;
            } else {
              self.orderBy = "BoothNo";
            }
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    ExpoClick: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().EnableEnhancedExpoMode === true) {
                  store.commit("setAdvExpo", true);
                  $(".page-effect").show();
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              });
            })
            .catch((error) => {
              alert(error);
            });
        }
      }
    },
    selectExpoMenu: function () {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      //$("#liexhibitor").first().addClass("active");
    },
    removeSelection: function () {
      $("#liexhibitor")
        .find("a:first")
        .removeClass("router-link-exact-active router-link-active");
    },
    getExpoBackground: function () {},
  },
  beforeMount() {
    this.ExpoClick();
  },
  async mounted() {
    self = this;
    this.getfilters();
    if (self.DropFilter.length > 1) {
      $("#dvFiltermain").removeClass("d-none");
    } else {
      $("#dvFiltermain").addClass("d-none");
    }
    var obj = JSON.parse(window.localStorage.getItem("my-app"));

    if (obj.expoToolTip == true) {
      self.showTooltips = true;
    } else {
      self.showTooltips = false;
    }

    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black !important";
          }
        } else {
          self.textColor = "black !important";
        }
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }

    if (this.DropFilter.length == 0) {
      this.getfilters();
    }

    $("#topmenu").show();
    $("#leftmenu").show();

    $("#btnAddUserView").click();
    self.searchtext = "";
    self.getSettings();

    setTimeout(() => {
      self.getExhibitors();
    }, 1000);

    interval = setInterval(() => {
      this.selectExpoMenu();
    }, 2000);

    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                self.headerText = value.DisplayLabel_es;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "Exhibitors") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                self.headerText = value.DisplayLabel_es;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
          }
        });
        document.title = self.headerText + " - " + obj.eventname;
      });

    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    this.hallGridView();
  },
  beforeDestroy() {
    this.lastVisible = null;
    self.Exhibitorlist = [];
    self.filterText = "";
    self.DropFilter = [];
    self.searchtext = "";
    clearInterval(interval);
    self.removeSelection();
  },
  computed: {
    getAdvExpoflag() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.advExpo;
    },
  },
};
</script>